import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';

export enum AIQuestionType {
  CODING = 'Coding',
  OBJECTIVE = 'Objective',
  VIDEO = 'Subjective Video',
}

export interface language {
  name: string;
  id: number;
  onlineJudgeId: number;
  monaco_id: string;
}

interface IVideoQuestionUpdateType {
  attemptLeft: number;
  lastAttempt: null | {
    video: string;
    transcription: string;
  };
  storageData: null | {
    location: string;
    env: 'HH_API' | null;
  };
  maxTimeAllowed: number;
  lastAttemptSubmitted: boolean;
}

export interface testcase {
  test_case_id: string;
  input: string;
  output: string;
  score: string;
}

export interface AIQuestionModal {
  question_id: string;
  index: number;
  title: string;
  description: string;
  choice: { option: string; value: string }[];
  answer: string;
  time_taken: number;
  start_time: string;
  langauges: language[];
}

export interface code {
  tail: string;
  head_body: string;
}

export interface StreamResponse {
  id: string;
  offer: RTCSessionDescriptionInit;
  ice_servers: RTCIceServer[];
  session_id: string;
}

export interface AIWebRTCState {
  peerConnection: RTCPeerConnection | null;
  streamId: string | null;
  sessionId: string | null;
  streamResponse: StreamResponse;
}

const initialState: AIWebRTCState = {
  peerConnection: null,
  streamId: null,
  sessionId: null,
  streamResponse: {
    id: '',
    offer: {
      type: 'offer',
      sdp: '',
    },
    ice_servers: [],
    session_id: '',
  },
};

export const AIWebRTCSlice = createSlice({
  name: 'aiwebrtc',
  initialState,
  reducers: {
    setPeerConnection: (
      state,
      action: PayloadAction<RTCPeerConnection | null>
    ) => {
      state.peerConnection = action.payload;
    },
    setStreamId: (state, action: PayloadAction<string | null>) => {
      state.streamId = action.payload;
    },
    setSessionId: (state, action: PayloadAction<string | null>) => {
      state.sessionId = action.payload;
    },
    setStreamResponse: (state, action: PayloadAction<StreamResponse>) => {
      state.streamResponse = action.payload;
    },
  },
});

export const {
  setPeerConnection,
  setStreamId,
  setSessionId,
  setStreamResponse,
} = AIWebRTCSlice.actions;

export default AIWebRTCSlice.reducer;
